import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Users } from '../users/users';

export const Promotions = new Mongo.Collection('flight_promotions');
export const Promotion = new SimpleSchema({
    title: {
        type: String,
        label: "Titre"
    },
    percentage: {
        type: SimpleSchema.Integer,
        label: "Pourcentage de réduction"
    },
    constraintOfUsers: {
        type: SimpleSchema.Integer,
        label: "Nombre min. de passagers" 
    },
    reference: {
        type: String,
        label: "Référence sur le site internet",
        optional: true
    },
    createdAt: {
        type: Date,
        label: "Date de création"
    }
  });

Promotions.attachSchema(Promotion);

// Dbs methods : 

Meteor.methods({
  'promotions.remove'(promotionId) {
    Promotions.remove(promotionId);
  },
  'promotions.update'({_id, attributes}) {
    Promotions.update(_id, { "$set": attributes }); 
  },
  'promotions.insert'({attributes}) {
    Promotions.insert(attributes); 
  }
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights-type/promotions.js
 **/